import { z } from 'zod';

/////////////////////////////////////////
// TEMPLATE SCHEMA
/////////////////////////////////////////

export const TemplateSchema = z.object({
  templateId: z.number().int(),
  cityId: z.number().int(),
  templateName: z.string(),
  templateType: z.string(),
  defaultSet: z.number().int(),
  template: z.string(),
  width: z.number().int(),
  height: z.number().int(),
  emailType: z.string(),
  description: z.string(),
  reportType: z.string(),
  disabled: z.number().int(),
  displayOrder: z.number().int(),
  groupName: z.string(),
  whenDue: z.string(),
  nextReminder: z.string(),
  letterhead: z.number().int(),
  letterVersion: z.number().int(),
  notes: z.string(),
})

export type Template = z.infer<typeof TemplateSchema>

export default TemplateSchema;
